<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Operator</mat-label>
    <textarea matInput formControlName="raw"></textarea>
  </mat-form-field>
</ng-container>
@if (getFormControl('raw').errors?.invalidJson) {
  <div i18n>
  Invalid JSON.
</div>
}
